@file:Suppress("DEPRECATION")

package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.BSTooltip
import com.stevdza.san.kotlinbs.components.initializeTooltips
import com.stevdza.san.kotlinbs.models.TooltipDirection
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.overflowWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleDown
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleUp
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.FaLeaf
import com.varabyte.kobweb.silk.components.icons.fa.FaMagnifyingGlass
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.components.icons.fa.FaPenToSquare
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.FaTrashCan
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubSeasonData
import org.example.zone360.style.DropdownStyleDark
import org.example.zone360.style.DropdownStyleLight
import org.example.zone360.theme.AvatarColors
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants.FONT_FAMILY
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.formatSeasonDate
import org.example.zone360.utils.formatUpdatedAt
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.Event


@Composable
fun CommonDropdown(
    isDownloadButton: Boolean = false,
    data: List<String>,
    onSelect: (String) -> Unit,
    selectedItem: String,
    width: CSSLengthOrPercentageNumericValue = 100.px,
    height: CSSLengthNumericValue = 45.px,
    isPagination: Boolean = false,
    disabled: Boolean = false,
    id: String = "",
    listWidth: CSSLengthOrPercentageNumericValue = width,
    leftRightPadding: CSSLengthNumericValue = 20.px
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val modifier = if (isPagination) Modifier.width(70.px) else Modifier.fillMaxWidth()
    var isHovered by remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .margin(topBottom = 0.px)
            .classNames(if (disabled) "disabled" else "dropdown")
            .id("menuDropDown")
            .width(width)
            .height(height)
            .id(id)
            .overflow(Overflow.Visible)
            .borderRadius(5.px)
            .color(if (disabled) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
            .border(
                width = if (disabled) 0.px else 1.px,
                style = LineStyle.Solid,
                color = if (isDownloadButton) sitePalette.primary.rgb else sitePalette.textFieldBorderColor.rgb
            )
            .backgroundColor(if (disabled) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.modalBackgroundColor.rgb)
            .cursor(Cursor.Pointer)
            .attrsModifier {
                attr("data-bs-toggle", "dropdown")
                attr("id", "dropdown1")
            }
    ) {
        Row(
            modifier = Modifier
                .fillMaxSize()
                .padding(leftRight = leftRightPadding),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            SpanText(
                modifier = Modifier
                    .fillMaxWidth()
                    .fontSize(13.px)
                    .fontFamily(FONT_FAMILY)
                    .overflow(Overflow.Hidden)                    // ← add this
                    .textOverflow(TextOverflow.Ellipsis)          // ← add this
                    .whiteSpace(WhiteSpace.NoWrap)
                    .color(if (isDownloadButton) sitePalette.primary.rgb else if (disabled) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb),
                text = selectedItem
            )
            if (isDownloadButton) {
                FaDownload(Modifier.color(sitePalette.primary.rgb))
            } else {
                Box(modifier = Modifier.classNames("dropdown-toggle"))
            }
        }
        Ul(
            attrs = Modifier
                .width(listWidth)
                .classNames("dropdown-menu").backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .attrsModifier {
                    style {
                        property("min-width", listWidth.toString())
                    }
                }
                .toAttrs()
        ) {
            val colorMode = ColorMode.current
            val modifier1 =
                if (colorMode == ColorMode.LIGHT) DropdownStyleLight else DropdownStyleDark

            data.forEach { item ->
                Li {
                    A(
                        attrs = modifier1.toModifier()
                            .classNames("dropdown-item")
                            .fontFamily(FONT_FAMILY)
                            .fontSize(16.px)
                            .onClick { onSelect(item) }
                            .toAttrs()
                    ) {
                        SpanText(
                            text = item,
                            modifier = Modifier
                                .fillMaxWidth()
                                .color(sitePalette.textFieldTextColor.rgb)
                                .fontSize(13.px)
                                .fontFamily(FONT_FAMILY)
                                .whiteSpace(WhiteSpace.PreWrap)
                                .overflowWrap(OverflowWrap.Anywhere)

                        )
                    }
                }
            }
        }
    }
}


@Composable
fun SeasonSelectorPopover(
    seasons: List<GetClubSeasonData>,
    selectedSeasonId: String,
    onSelect: (GetClubSeasonData?) -> Unit,
    onAddSeason: () -> Unit,
    onEditSeason: (GetClubSeasonData) -> Unit,
    onDeleteSeason: (GetClubSeasonData) -> Unit,
    width: CSSLengthOrPercentageNumericValue = 320.px,
    isAdmin: Boolean,
    showDefaultSeason: Boolean,
    breakpoint: Breakpoint
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val dropdownId = Res.Id.seasonDropdown
    var expanded by remember { mutableStateOf(false) }
    var searchText by remember { mutableStateOf("") }

    val selectedSeason =
        seasons.firstOrNull { it.id == selectedSeasonId }
            ?: seasons.firstOrNull { it.status.lowercase() == Strings.ACTIVE }

    val activeSeason =
        seasons.firstOrNull { it.status.lowercase() == Strings.ACTIVE }

    val filteredDefaults =
        if (showDefaultSeason && Strings.DEFAULT_SEASON.contains(searchText, ignoreCase = true))
            listOf(Strings.DEFAULT_SEASON)
        else emptyList()

    val filtered =
        seasons.filter { it.name.contains(searchText, ignoreCase = true) }

    val displayName = when {
        AppGlobal.selectedSeason == Strings.DEFAULT_SEASON -> Strings.DEFAULT_SEASON
        selectedSeason != null -> selectedSeason.name
        else -> ""
    }

    DisposableEffect(expanded) {
        if (expanded) {
            val listener: (Event) -> Unit = { event ->
                val target = event.target as? HTMLElement
                val root = document.getElementById(dropdownId)
                if (target != null && root?.contains(target) == false) {
                    expanded = false
                }
            }
            document.addEventListener("click", listener, true)
            onDispose { document.removeEventListener("click", listener, true) }
        } else {
            onDispose {}
        }
    }

    LaunchedEffect(expanded) {
        if (expanded) initializeTooltips()
        else searchText = ""
    }

    Box(
        modifier = Modifier
            .width(250.px)
            .position(Position.Relative)
    ) {
        // HEADER
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .id(dropdownId)
                .height(40.px)
                .borderRadius(8.px)
                .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .cursor(Cursor.Pointer)
                .onClick { expanded = !expanded }
        ) {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(leftRight = 15.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically) {
                    if (displayName.isNotEmpty()) {
                        Box(
                            modifier = Modifier
                                .size(10.px)
                                .borderRadius(50.percent)
                                .backgroundColor(sitePalette.seasonActiveDot.rgb)
                        )
                    }
                    SpanText(
                        text = displayName,
                        modifier = Modifier
                            .margin(left = 12.px)
                            .fontSize(16.px)
                            .fontWeight(500)
                            .maxWidth(160.px)
                            .overflow(Overflow.Hidden)
                            .textOverflow(TextOverflow.Ellipsis)
                            .whiteSpace(WhiteSpace.NoWrap)
                    )
                }
                FaAngleDown()
            }
        }

        if (expanded) {
            Box(
                modifier = Modifier
                    .id(dropdownId)
                    .position(Position.Absolute)
                    .top(41.px)
                    .left(0.px)
                    .zIndex(999)
                    .width(width)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .borderRadius(12.px)
                    .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb)
                    .boxShadow(offsetY = 6.px, blurRadius = 24.px, color = sitePalette.boxShadowColor.rgb)
            ) {
                Column(modifier = Modifier.fillMaxWidth().padding(14.px)) {

                    // SEARCH ROW
                    Row(
                        modifier = Modifier.fillMaxWidth().height(44.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth(if (isAdmin) 86.percent else 100.percent)
                                .fillMaxHeight()
                                .borderRadius(8.px)
                                .backgroundColor(sitePalette.seasonSearchBackground.rgb)
                                .padding(leftRight = 8.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            FaMagnifyingGlass(
                                modifier = Modifier.margin(right = 10.px).color(Colors.Gray)
                            )
                            var isSearchFocused by remember { mutableStateOf(false) }
                            Input(
                                type = InputType.Text,
                                attrs = Modifier
                                    .width(100.percent)
                                    .height(32.px)
                                    .padding(leftRight = 8.px)
                                    .borderRadius(4.px)
                                    .border(
                                        1.px, LineStyle.Solid,
                                        if (isSearchFocused) sitePalette.primary.rgb
                                        else sitePalette.textFieldBorderColor.rgb
                                    )
                                    .outline(0.px, LineStyle.None, Colors.Transparent)
                                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                                    .color(sitePalette.textFieldTextColor.rgb)
                                    .fontSize(12.px)
                                    .fontFamily(FONT_FAMILY)
                                    .onFocusIn { isSearchFocused = true }
                                    .onFocusOut { isSearchFocused = false }
                                    .attrsModifier {
                                        attr("placeholder", "Search...")
                                        addEventListener("input") { event ->
                                            val target = event.target as? HTMLInputElement
                                            searchText = target?.value ?: ""
                                        }
                                    }
                                    .toAttrs()
                            )
                        }
                        if (isAdmin) {
                            Box(
                                modifier = Modifier
                                    .size(34.px)
                                    .borderRadius(8.px)
                                    .backgroundColor(sitePalette.primary.rgb)
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        expanded = false
                                        onAddSeason()
                                    },
                                contentAlignment = Alignment.Center
                            ) {
                                FaPlus(modifier = Modifier.color(Colors.White))
                            }
                        }
                    }

                    // ACTIVE SECTION
                    FieldTitleTextNormalSimple(
                        text = Strings.ACTIVE.uppercase(),
                        marginTop = 12.px,
                        fontSize = 10.px,
                        fontWeight = 700,
                        color = Colors.Gray
                    )

                    activeSeason?.let { season ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .margin(top = 6.px, bottom = 4.px)
                                .borderRadius(10.px)
                                .backgroundColor(sitePalette.primary.rgb.copyf(alpha = 0.15f))
                                .border(1.px, LineStyle.Solid, sitePalette.primary.rgb.copyf(alpha = 0.3f))
                                .padding(leftRight = 12.px, topBottom = 8.px)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    onSelect(season)
                                    expanded = false
                                }
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Row(
                                    modifier = Modifier.weight(1),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    // Letter box - active style
                                    Box(
                                        modifier = Modifier
                                            .size(32.px)
                                            .borderRadius(8.px)
                                            .margin(right = 10.px)
                                            .backgroundColor(sitePalette.primary.rgb.copyf(alpha = 0.25f))
                                            .border(1.px, LineStyle.Solid, sitePalette.primary.rgb.copyf(alpha = 0.4f)),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Box(
                                            modifier = Modifier.fillMaxSize(),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            SpanText(
                                                text = season.name.first().uppercaseChar().toString(),
                                                modifier = Modifier
                                                    .fontSize(13.px)
                                                    .fontWeight(FontWeight.Bold)
                                                    .lineHeight(13.px)
                                                    .color(sitePalette.primary.rgb)
                                            )
                                        }
                                    }
                                    Column(modifier = Modifier.weight(1)) {
                                        FieldTitleTextNormalSimple(
                                            season.name,
                                            fontSize = 14.px,
                                            fontWeight = 500,
                                            color = sitePalette.primary.rgb
                                        )
                                        if (season.updatedAt != null) {
                                            FieldTitleTextNormalSimple(
                                                "Updated ${formatUpdatedAt(season.updatedAt)}",
                                                fontSize = 11.px,
                                                color = sitePalette.primary.rgb.copyf(alpha = 0.6f),
                                                marginTop = 1.px
                                            )
                                        }
                                    }
                                }
                                Box(
                                    modifier = Modifier
                                        .borderRadius(20.px)
                                        .backgroundColor(sitePalette.seasonActiveBadge.rgb)
                                        .padding(leftRight = 10.px, topBottom = 4.px)
                                ) {
                                    FieldTitleTextNormalSimple(
                                        Strings.ACTIVE,
                                        fontSize = 11.px,
                                        fontWeight = 500,
                                        marginBottom = 0.6.px,
                                        color = Colors.White
                                    )
                                }
                            }
                        }
                    }

                    // ALL SEASONS
                    FieldTitleTextNormalSimple(
                        text = "ALL SEASONS",
                        marginTop = 8.px,
                        marginBottom = 4.px,
                        fontSize = 10.px,
                        fontWeight = 700,
                        color = Colors.Gray
                    )

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .maxHeight(320.px)
                            .overflow(Overflow.Auto)
                    ) {
                        // Default Season row
                        filteredDefaults.forEach { name ->
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(topBottom = 8.px)
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        onSelect(null)
                                        expanded = false
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Box(
                                    modifier = Modifier
                                        .size(30.px)
                                        .borderRadius(8.px)
                                        .backgroundColor(sitePalette.seasonItemIconBackground.rgb)
                                        .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb),
                                    contentAlignment = Alignment.Center
                                ) {
                                    SpanText(
                                        text = name.first().uppercaseChar().toString(),
                                        modifier = Modifier
                                            .fontSize(13.px)
                                            .fontWeight(FontWeight.Bold)
                                            .lineHeight(13.px)
                                            .color(sitePalette.textFieldSupportiveTextColor.rgb)
                                    )
                                }
                                Column(modifier = Modifier.weight(1).margin(left = 10.px)) {
                                    FieldTitleTextNormalSimple(name, fontWeight = 500, fontSize = 13.px)
                                }
                            }
                        }

                        // Regular seasons
                        filtered.forEach { season ->
                            var isHovered by remember { mutableStateOf(false) }
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(topBottom = 8.px)
                                    .cursor(Cursor.Pointer)
                                    .onMouseEnter { isHovered = true }
                                    .onMouseLeave { isHovered = false }
                                    .onClick {
                                        onSelect(season)
                                        expanded = false
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            )
                            {
                                // Letter box
                                val colorIndex = kotlin.math.abs(season.name.hashCode()) % AvatarColors.size
                                val (bgColor, textColor) = AvatarColors[colorIndex]
                                Box(
                                    modifier = Modifier
                                        .size(32.px)
                                        .borderRadius(8.px)
                                        .backgroundColor(bgColor)
                                        .border(1.px, LineStyle.Solid, bgColor.darkened(0.15f)),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Box(
                                        modifier = Modifier.fillMaxSize(),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        SpanText(
                                            text = season.name.first().uppercaseChar().toString(),
                                            modifier = Modifier
                                                .fontSize(13.px)
                                                .fontWeight(FontWeight.Bold)
                                                .lineHeight(13.px)
                                                .color(textColor)
                                        )
                                    }
                                }
//                                Box(
//                                    modifier = Modifier
//                                        .size(30.px)
//                                        .borderRadius(8.px)
//                                        .backgroundColor(bgColor)
//                                        .border(1.px, LineStyle.Solid, bgColor.darkened(0.15f)),
//                                    contentAlignment = Alignment.Center
//                                ) {
//                                    FieldTitleTextNormalSimple(
//                                        text = season.name.first().uppercaseChar().toString(),
//                                        fontSize = 12.px,
//                                        fontWeight = 700,
//                                        lineHeight = 13.px,
//                                        color = textColor
//                                    )
//                                }
                                Column(modifier = Modifier.weight(1).margin(left = 10.px)) {
                                    FieldTitleTextNormalSimple(
                                        season.name,
                                        fontWeight = 500,
                                        fontSize = 13.px
                                    )
                                    if (season.updatedAt != null) {
                                        FieldTitleTextNormalSimple(
                                            "Updated ${formatUpdatedAt(season.updatedAt)}",
                                            fontSize = 11.px,
                                            color = Colors.Gray,
                                            marginTop = 2.px
                                        )
                                    }
                                }
                                if (isAdmin) {
                                    val showActions = if (breakpoint > Breakpoint.MD) isHovered else true
                                    if (showActions) {
                                        Box(
                                            modifier = Modifier
                                                .padding(8.px)
                                                .margin(right = 6.px)
                                                .borderRadius(8.px)
                                                .backgroundColor(sitePalette.seasonItemIconBackground.rgb)
                                                .border(0.5.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb)
                                                .cursor(Cursor.Pointer)
                                                .onClick { event ->
                                                    event.stopPropagation()
                                                    onEditSeason(season)
                                                },
                                            contentAlignment = Alignment.Center
                                        ) {
                                            FaPenToSquare(
                                                modifier = Modifier
                                                    .color(sitePalette.textFieldTextColor.rgb.copyf(alpha = 0.5f))
                                                    .cursor(Cursor.Pointer)
                                            )
                                        }
                                            Box(
                                                modifier = Modifier
                                                    .padding(8.px)
                                                    .borderRadius(8.px)
                                                    .backgroundColor(sitePalette.primary.rgb.copyf(alpha =  if (season.status.lowercase() != Strings.ACTIVE) 0.08f else 0.04f))
                                                    .border(0.5.px, LineStyle.Solid, sitePalette.primary.rgb.copyf(alpha = 0.2f))
                                                    .cursor(Cursor.Pointer)
                                                    .onClick { event ->
                                                        event.stopPropagation()
                                                        if (season.status.lowercase() != Strings.ACTIVE) {
                                                            onDeleteSeason(season)
                                                        }else{
                                                            return@onClick
                                                        }
                                                    },
                                                contentAlignment = Alignment.Center
                                            ) {
                                                FaTrashCan(
                                                    modifier = Modifier
                                                        .color( if (season.status.lowercase() != Strings.ACTIVE) sitePalette.primary.rgb else sitePalette.primary.rgb.copyf(alpha = 0.3f) )
                                                        .cursor(Cursor.Pointer)
                                                )
                                            }

                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

